//trackFinishSurvey
import { ca } from '@cian/analytics';
import { TPage } from '../../types/analytics/page';

/**
 * Сохранение ответов опроса по кнопке "Дальше" на последнем вопросе анкеты (перед шагом появления формы ОЗ)
 * https://conf.cian.tech/pages/viewpage.action?pageId=1469162427
 */
export const trackFinishSurvey = (page: TPage) => {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'Finish_newbuilding_kpn_survey',
    label: '/sale/flat/object_type=2/from_developer=1/',
    name: 'oldevent',
    page,
  });
};
